export default __webpack_public_path__ + "static/media/edit-svg-black.7777552d.svg";